export enum Roles {
    Developer = "AladdinTechnology",

    PortalAdmin = "Portal.Admin",
    PortalSuperUser = "Portal.SuperUser",
    PortalUser = "Portal.User",
    PortalInternal = "Portal.Internal",
    PortalReportDesigner = "Portal.ReportDesigner",

    CarrierUser = "Carrier.User",
    LeadsUser = "Leads.User",
    ConvertedLeads = "ConvertedLeads.User",

    TsUser = "TS.User",
    TsAdmin = "TS.Admin", //TSInternalAdmin
    TsReportDesigner = "TS.ReportDesigner",
    TSELDManager = "TS.ELDManager",
    TSInternalManager = "TS.InternalManager",
    TSInternalAccounting = "TS.InternalAccounting",
    TSInternalSafety = "TS.InternalSafety",
    TSInternalAgent = "TS.InternalAgent",
    TsIFTAUploader  = "TS.IFTAUploader",
    TSInvoiceEditor = "TS.InvoiceEditor",
    TSInvoiceAssigner = "TS.InvoiceAssigner",
    TSNoteAdmin = "TS.NoteAdmin",

    TSCustomerAdmin = "TS.CustomerAdmin",
    TSCustomerOperations = "TS.CustomerOperations",
    TSCustomerAccounting = "TS.CustomerAccounting",
    TSCustomerSafety = "TS.CustomerSafety",
    TSCustomerHR = "TS.CustomerHR",
    TSCustomerDispatch = "TS.CustomerDispatch",
    TSCustomerMaintenance = "TS.CustomerMaintenance",
    TSCustomerDriver = "TS.CustomerDriver",

    TSDocuSign = "TS.DocuSign",

    CreditCheckDisabled = "Sales.User",
    VIPUser = "VIP.User",

    SecureCanRead = "Secure.CanRead",
}



// WEBPACK FOOTER //
// ./src/app/auth/roles.enum.ts